export function TradesmenLogo({ className }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      {/* Background circle */}
      <circle cx="60" cy="60" r="56" fill="currentColor" fillOpacity="0.15" />

      {/* Building outline - commercial property */}
      <path
        d="M30 40 L30 85 L40 85 L40 75 L50 75 L50 85 L60 85 L60 70 L70 70 L70 85 L80 85 L80 85 L90 85 L90 40 Z"
        stroke="currentColor"
        strokeWidth="3"
        fill="currentColor"
        fillOpacity="0.2"
      />

      {/* Windows - grid pattern */}
      <rect x="35" y="45" width="8" height="8" rx="1" fill="currentColor" fillOpacity="0.6" />
      <rect x="47" y="45" width="8" height="8" rx="1" fill="currentColor" fillOpacity="0.6" />
      <rect x="35" y="57" width="8" height="8" rx="1" fill="currentColor" fillOpacity="0.6" />
      <rect x="47" y="57" width="8" height="8" rx="1" fill="currentColor" fillOpacity="0.6" />

      {/* Door */}
      <rect x="38" y="68" width="14" height="17" rx="2" fill="currentColor" fillOpacity="0.4" />

      {/* Wrench - represents services */}
      <g transform="translate(65, 45) rotate(15)">
        <path
          d="M20 0 L24 4 L8 20 L4 16 Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="1.5"
        />
        <circle cx="22" cy="2" r="6" stroke="currentColor" strokeWidth="2" fill="none" />
        <path d="M22 2 L22 8" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
        <path d="M22 2 L28 2" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
        <path d="M22 2 L16 2" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      </g>

      {/* Shield with checkmark - represents trust/verification */}
      <g transform="translate(72, 68)">
        <path
          d="M0 0 L12 0 L12 14 C12 18 6 22 6 22 C6 22 0 18 0 14 Z"
          fill="currentColor"
          fillOpacity="0.3"
          stroke="currentColor"
          strokeWidth="2"
        />
        <path
          d="M3 10 L5 12 L9 6"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
      </g>
    </svg>
  );
}